module.exports = __webpack_public_path__ + "img/initialEle.7f258f0f.svg";